import { Helmet } from 'react-helmet-async';

export function WebsiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "LocalCraft Israel",
    "url": "https://localcraftisrael.com",
    "description": "Discover authentic handmade products from verified Israeli artisans. Support local craftspeople and find exclusive items.",
    "publisher": {
      "@type": "Organization",
      "name": "LocalCraft Israel"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://localcraftisrael.com/catalog?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "inLanguage": ["en", "he", "ru", "es"]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
